/**
 * Types du joueur DAG côté élève. Miroir du payload ASSAINI renvoyé par la RPC
 * `get_dag_for_player` (migration 0171) : AUCUN `correct`, `misconception_id`,
 * `resultat`, `outil_id` ni arête — la validation est 100 % serveur.
 */

export type DagSubnodeTrigger = 'on_error' | 'on_request' | 'always';

export interface PlayerIndice {
  id: string;
  span_debut: number;
  span_fin: number;
  type: 'donnee' | 'hypothese_implicite' | 'resultat_anterieur';
  valeur: string | null;
}

export interface PlayerNoeud {
  id: string;
  kind: 'dispatch' | 'inference';
  ordre: number;
  enonce_qcm: string | null;
  is_sub: boolean;
  subnode_of: string | null;
  subnode_trigger: DagSubnodeTrigger;
}

export interface PlayerChoix {
  id: string;
  noeud_id: string;
  label: string;
}

export interface PlayerAccess {
  allowed: boolean;
  reason: string;
}

export interface PlayerDag {
  exercise_id: string;
  access: PlayerAccess;
  enonce: string | null;
  dag: { id: string; niveau: string; type_id: string; statut: string };
  indices: PlayerIndice[];
  noeuds: PlayerNoeud[];
  choix: PlayerChoix[];
}

export type PlayerDagResult = PlayerDag | { error: string; reason?: string };

export function isPlayerDag(r: PlayerDagResult | null | undefined): r is PlayerDag {
  return !!r && 'noeuds' in r;
}

export interface StartAttemptResult {
  attempt_id?: string;
  dag_id?: string;
  error?: string;
  reason?: string;
}

export interface SubmitAnswerResult {
  correct: boolean;
  subnode_to_play: string | null;
  next_noeud_id: string | null;
  feedback: string;
  score_delta: number;
  fished_relevant: string[];
  fished_irrelevant: string[];
}

export interface CompleteAttemptResult {
  ok?: boolean;
  total_score?: number;
  xp_gain?: number;
  status?: string;
  error?: string;
}

export interface SubmitAnswerInput {
  attempt_id: string;
  noeud_id: string;
  choix_id: string | null;
  indices_peches: string[];
  request_subnode: boolean;
}
